import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Dialog from '@mui/material/Dialog';
import Box from '@mui/material/Box';
import LoadingButton from '@mui/lab/LoadingButton';
import DialogContent from '@mui/material/DialogContent';

import { Select } from '../select';

const ManageCredentialsDialog = ({ toast, open, handleClose, isLoading, userToEdit, setEditedUserData }) => {
  const roles = { "site-leader": 'SITE-LEADER', "edifier": "COACH", "teacher": 'TEACHER' }
  const submit = (e) => {
    e.preventDefault();
    console.log(e.target[0].value);

    // if (userToEdit?.role.toLowerCase() === e.target[0].value) {
    //   toast.error('Change the Role to Submit Data');
    //   return;
    // }
    setEditedUserData({ id: userToEdit?._id, role: roles[e.target[0].value] });
  };


  // console.log(userToEdit);

  let defaultRole;

  if (userToEdit.totalRoles?.length) {
    if (userToEdit.totalRoles.includes('SITE-LEADER')) {
      defaultRole = 'site-leader';
    } else if (userToEdit.totalRoles.includes('COACH')) {
      defaultRole = 'edifier';
    } else {
      defaultRole = userToEdit.role?.toLowerCase();
    }
  } else {
    defaultRole = userToEdit.role?.toLowerCase() === 'coach'
      ? 'edifier'
      : userToEdit.role?.toLowerCase();
  }


  console.log(defaultRole);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      sx={{
        '& .MuiPaper-root': {
          width: { xs: '350px', sm: '649px' },
          height: 'max-content',
          borderRadius: '20PX',
        },
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', p: '20px' }}>
        <Typography variant="h4" sx={{ color: 'text.titles' }}>
          Change Role
        </Typography>
        <CloseIcon sx={{ cursor: 'pointer' }} onClick={handleClose} />
      </Box>
      <DialogContent>

        <form onSubmit={submit}>
          <Select
            field={{ name: 'roles', label: 'Role' }}
            items={['Teacher', 'Edifier', 'Site-Leader']}
            defaultValue={defaultRole}
          />

          <LoadingButton
            loading={isLoading}
            variant="contained"
            type="submit "
            color="main"
            sx={{ height: 'fit-content', my: 'auto', mt: '20px' }}
          >
            Submit
          </LoadingButton>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default ManageCredentialsDialog;
